import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type React from "react";
import { Button } from "../../../components/Theme/button";

interface UnretireAssetButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export default function UnretireAssetButton({
  onClick,
  disabled = false,
}: UnretireAssetButtonProps): React.ReactElement {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      color="green"
      size="sm"
      className="py-1"
    >
      <FontAwesomeIcon icon={faRotateLeft} fixedWidth className="mr-1" />
      Unretire Asset
    </Button>
  );
}
